import prominentTpl from 'templates/carousels/highlightCarousel/prominentCarousel/prominentCarousel.tpl';
import { ProminentDefaultBreakpointRules } from 'components/settings/BreakpointSettings';
import prominentCarousel from 'components/highlight/carousel/ProminentCarousel';

export default function ($wrapper, carouselData) {
    try {
        let $carouselElement = $wrapper.find('.js-video-carousel');

        let carousel = {
            wrapper: $carouselElement,
            init: function () {
                $wrapper.on('init', () => {
                    $carouselElement.removeClass('hidden');
                });

                $wrapper.on('setPosition', () => {
                    $wrapper.ellipsify();
                });

                let options = {
                    endPoint: carouselData.baseEndpoint,
                    params: {
                        slug: $wrapper.data('slug'),
                        sectionId: $wrapper.data('sectionid'),
                    },
                    template: prominentTpl,
                    responsive: ProminentDefaultBreakpointRules,
                };

                if (carouselData.options) {
                    options = { ...options, ...carouselData.options };
                }

                prominentCarousel({
                    parentContainer: $carouselElement[0],
                    options: options,
                });
            },
        };

        return carousel;
    } catch (e) {
        console.log(e);
    }
}
